import script from "./TournamentHero.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentHero.vue?vue&type=script&setup=true&lang=js"

import "./TournamentHero.vue?vue&type=style&index=0&id=17ceb120&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ceb120"]])

export default __exports__